<template>
  <div class="a7-painel-analise-parameter">
    <div class="filter-band">
      <div class="row-container">
        <div class="left">
          <span class="title"> {{this.titleText}}</span>
          <span class="subtitle"> {{this.subtitleText}} </span>
        </div>
        <div class="right">
          <gw-icon-button :icon="'fa-cog'" class="configurations" @click="showModal"/>
        </div>
      </div>

      <gw-filter-band v-model="localFilters.filterParams">
        <a7-unidade-negocio-filter-item
          :display-text="$t('PainelAnalise.ui.filtroUnidadeNegocio')"
          property-name="unidadesNegocio"/>
        <a7-visao-filter-item
          :display-text="$t('PainelAnalise.ui.filtroVisao')"
          property-name="visoes"/>
        <gw-text-filter-item
          :display-text="$t('PainelAnalise.ui.filtroGrupoClienteAlpha7')"
          property-name="grupoClienteAlpha7"/>
      </gw-filter-band>
    </div>

    <gw-modal-dialog :visible="modalVisible" @hide="modalVisible=false">
      <span slot="modal-header">Configurações</span>
      <div slot="modal-body">
        <div class="config-block">
          <label>{{$t('PainelAnalise.visaoConfiguracoes.periodo.titulo')}}</label>
          <div class="options">
            <gw-button v-for="(value, key) in periodoConstants" :key="key"
            :class="{'default': key === selected['periodo']}"
            @click="setSelectedConfiguration('periodo', key)">
              <span>{{value}}</span>
            </gw-button>
          </div>
        </div>
        <div class="config-block">
          <label>{{$t('PainelAnalise.visaoConfiguracoes.comparador.titulo')}}</label>
          <div class="options">
            <gw-button v-for="(value, key) in comparadorConstants" :key="key"
            :class="{'default': key === selected['comparador']}"
            :disabled="'F' === selected['periodo']"
            @click="setSelectedConfiguration('comparador', key)">
              <span>{{value}}</span>
            </gw-button>
          </div>
        </div>
        <div class="config-block">
          <label>{{$t('PainelAnalise.visaoConfiguracoes.intervalo.titulo')}}</label>
          <div class="options">
            <gw-button v-for="(value, key) in intervaloConstants" :key="key"
            :class="{'default': key === selected['intervalo']}"
            :disabled="'A' === selected['periodo']"
            @click="setSelectedConfiguration('intervalo', key)">
              <span>{{value}}</span>
            </gw-button>
          </div>
        </div>
      </div>
      <div slot="modal-footer">
        <div class="options">
          <gw-button @click="applyConfigurations"> {{'Ok'}} </gw-button>
          <gw-button @click="hideModal"> {{'Cancelar'}} </gw-button>
        </div>
      </div>
    </gw-modal-dialog>
  </div>
</template>

<script>
import {
  GwFilterBand,
  GwTextFilterItem,
  GwSelect,
  GwModalDialog,
  GwButton,
  GwIconButton
} from 'guaxinim-web'
import A7UnidadeNegocioFilterItem from '../unidadeNegocio/A7UnidadeNegocioFilterItem'
import A7VisaoFilterItem from '../visao/A7VisaoFilterItem'
import {defaultFilterConfiguration} from './A7PainelAnaliseDefaultConfigurations'

export default {
  name: "a7-painel-analise-parameter",
  components: {
    GwFilterBand,
    GwTextFilterItem,
    GwSelect,
    GwModalDialog,
    GwButton,
    GwIconButton,
    A7UnidadeNegocioFilterItem,
    A7VisaoFilterItem
  },
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  data(){
    return {
      modalVisible: false,
      titleText: 'Nenhuma configuração definida',
      subtitleText: '',
      selected: {},
      localFilters: {
        filterParams: {},
        configurations: {...defaultFilterConfiguration}
      },
      periodoConstants: {
        'A': this.$t('PainelAnalise.visaoConfiguracoes.periodo.A'),
        'B': this.$t('PainelAnalise.visaoConfiguracoes.periodo.B'),
        'C': this.$t('PainelAnalise.visaoConfiguracoes.periodo.C'),
        'D': this.$t('PainelAnalise.visaoConfiguracoes.periodo.D'),
        'E': this.$t('PainelAnalise.visaoConfiguracoes.periodo.E'),
        'F': this.$t('PainelAnalise.visaoConfiguracoes.periodo.F')
      },
      comparadorConstants: {
        'A': this.$t('PainelAnalise.visaoConfiguracoes.comparador.A'),
        'B': this.$t('PainelAnalise.visaoConfiguracoes.comparador.B')
      },
      intervaloConstants: {
        'A': this.$t('PainelAnalise.visaoConfiguracoes.intervalo.A'),
        'B': this.$t('PainelAnalise.visaoConfiguracoes.intervalo.B')
      }
    }
  },
  methods: {
    showModal(){
      this.selected = {...this.localFilters.configurations}
      this.modalVisible = true
    },
    hideModal(){
      this.modalVisible = false
    },
    applyConfigurations(){
      this.localFilters.configurations = {...this.selected}
      this.hideModal()
    },
    setSelectedConfiguration(to, option) {
      this.selected[to] = option
      if (this.selected.periodo === 'A')
        this.selected.intervalo = 'B'
      else if (this.selected.periodo === 'F')
        this.selected.comparador = 'B'
    },
    emitInput() {
      this.$emit('input', this.localFilters)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep:true,
      handler(value) {
        this.localfilters = value
      }
    },
    localFilters:{
      deep: true,
      handler() {
        const periodo = this.periodoConstants[this.localFilters.configurations.periodo]
        const comparador = this.comparadorConstants[this.localFilters.configurations.comparador]
        const intervalo = this.intervaloConstants[this.localFilters.configurations.intervalo]
        this.titleText = `${periodo} atual x ${comparador}`
        this.subtitleText = `${this.$t('PainelAnalise.ui.filterBandSubtitle')} ${intervalo}`
        this.emitInput()
      }
    }
  }
}
</script>


<style media="screen">
  .a7-painel-analise-parameter .gw-filter-band-container{
    padding: 0px!important;
  }
</style>

<style lang="scss" scoped>
@import 'guaxinim-web/src/css/MediaBreakpoints.scss';
@import 'guaxinim-web/src/css/color-palette.scss';

.config-block{
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin-bottom: 15px;
  .options{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 5px;
    @include lg {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

.modal-footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.filter-band {
  display: flex;
  flex-direction: column;
  width: 100%;
  .title {
    font-weight: 700;
  }
  .subtitle {
    color:$grey-darker;
  }
  .row-container{
    display: flex;
    margin-bottom: 5px;
    .left{
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
    .right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 20px;
    }
  }

}

.a7-painel-analise-parameter {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 10px;
  .select {
    width: 250px;
    margin-left: 4px;
  }
  @include lg {
    flex-direction: row;
    align-items: center;
    margin-top: 0px;
    .select{
      margin-left: 3px;
    }
  }
}
</style>
